var acc = document.getElementsByClassName("faq-accordion");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      var isActive = this.classList.contains("active");

      // Close all accordions
      var allPanels = document.getElementsByClassName("product-decs-panel");
      for (var j = 0; j < allPanels.length; j++) {
        allPanels[j].style.display = "none";
      }

      // Remove active class from all accordions
      var allAccordions = document.getElementsByClassName("faq-accordion");
      for (var k = 0; k < allAccordions.length; k++) {
        allAccordions[k].classList.remove("active");
      }

      // Open clicked accordion if it wasn't active
      if (!isActive) {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        panel.style.display = "block";
      }
    });
  }